//Set data for confirm modal
import {notification} from "../helpers/notification";

$(function () {
    let fieldName = false;
    let modal = $('.js-confirmation-modal');
    let withOutAjax = false;
    $(document).on('click', '.js-open-confirmation', function(e) {
        e.preventDefault();
        let url = $(this).data('url');
        let method = $(this).data('method');
        let status = $(this).data('status');
        let message = $(this).data('message');
        withOutAjax = $(this).data('without-ajax');
        fieldName = $(this).data('field');
        $('.js-confirmation-form').attr('action', url);
        $('.js-confirmation-message').text(message);
        $('.js-confirm-btn').attr('value', status).attr('data-method', method);
    })
//Set data for confirm modal

//Confirm data with ajax
    modal.on('click', '.js-confirm-btn', function(e) {
        e.preventDefault();
        let form = $('.js-confirmation-form');
        let data = null;
        if($(this).attr('value')) {
            if(fieldName){
                data = form.serialize() + '&'+fieldName+'=' + $(this).attr('value');
            }else{
                data = form.serialize() + '&status=' + $(this).attr('value');
            }
        } else {
            data = form.serialize();
        }
        if(withOutAjax){
            form.append(`<input type="hidden" name="_method" value="${$(this).data('method')}"/>`);
            if(fieldName){
                form.append(`<input type="hidden" name="${fieldName}" value="${$(this).attr('value')}"/>`);
            }else{
                form.append(`<input type="hidden" name="status" value="${$(this).attr('value')}"/>`);
            }
            form.submit();
        }else{
            $.ajax({
                type: $(this).data('method'),
                url: form.attr('action'),
                data: data,
                success: function(response) {
                    if(response.hasOwnProperty('checked')) {
                        $(`.js-change-active[data-id="${response.id}"]`)
                            .prop('checked', response.checked ? 0 : 1)
                            .data('status', response.checked ? 0 : 1)
                            .trigger('change');
                    }
                    modal.modal('hide');
                    notification(response.type, response.message);
                },
                error: function(xhr) {
                    let response = JSON.parse(xhr.responseText);
                    notification(response.type, response.message);
                    modal.modal('hide');
                }
            })
        }
    })
//Confirm data with ajax end
})

